import { HelperService } from './../services/helper.service';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
export class CustomUtils {
  static fb = new FormBuilder();

  constructor(
    public helperService: HelperService,
    public store: Store<{ config: any }>
  ) {}

  static getFormField(formGroup: FormGroup, formField: string) {
    return formGroup.get(formField) as FormArray;
  }

  static getLocale(formGroup: FormGroup) {
    return <FormGroup>formGroup.get(`locale`);
  }

  static getFormGroup(formGroup: FormGroup, path: string) {
    return <FormGroup>formGroup.get(path);
  }

  static getLangFormGroup(formGroup: FormGroup, langCode: string) {
    return <FormGroup>formGroup.get(`locale.${langCode}`);
  }

  static getLangAttachments(formGroup: FormGroup, langCode: string) {
    return formGroup.get(`locale.${langCode}.attachments`) as FormArray;
  }

  static createQueryString(form) {
    const query = new URLSearchParams(form).toString().replace('null', '');
    return query;
  }
}
